import React from 'react';
import FloatingLabelInput from './FloatingLabelInput';
import FormatStandardDate from './FormatStandardDate';

export const PatientDetails = ({ patient }) => {
  if (!patient) return null;

  return (
    <>
      <h4>Patient Details</h4>
      <div className="px-md-3">
        <div className="row justify-content-start">
          <div className="col-md-3 px-md-1">
            <FloatingLabelInput id="lastName" label="Patient LastName" backcolor="gray" value={patient.lastName} readOnly="readOnly" />
          </div>
          <div className="col-md-3 px-md-1">
            <FloatingLabelInput id="firstName" label="Patient FirstName" backcolor="gray" value={patient.firstName} readOnly="readOnly" />
          </div>
          <div className="col-md-2 px-md-1">
            <FloatingLabelInput id="dob" label="Date of Birth" backcolor="gray" value={FormatStandardDate(patient.dob)} readOnly="readOnly" />
          </div>
          <div className="col-md-2 px-md-1">
            <FloatingLabelInput id="mrn" label="MRN" backcolor="gray" value={patient.mrn} readOnly="readOnly" />
          </div>
          <div className="col-md-2 px-md-1">
            <FloatingLabelInput id="siisId" label="SiisId" backcolor="gray" value={patient.patientId} readOnly="readOnly" />
          </div>
        </div>
        <div className="row justify-content-start">
          <div className="col-md-3 px-md-1">
            <FloatingLabelInput id="address1" label="Address1" backcolor="gray" value={patient.address1} readOnly="readOnly" />
          </div>
          <div className="col-md-3 px-md-1">
            <FloatingLabelInput id="address2" label="Patient Address2" backcolor="gray" value={patient.address2} readOnly="readOnly" />
          </div>
          <div className="col-md-2 px-md-1">
            <FloatingLabelInput id="city" label="City" backcolor="gray" value={patient.city} readOnly="readOnly" />
          </div>
          <div className="col-md-1 px-md-1">
            <FloatingLabelInput id="state" label="State" backcolor="gray" value={patient.state} readOnly="readOnly" />
          </div>
          <div className="col-md-1 px-md-1">
            <FloatingLabelInput id="zip" label="Zip" backcolor="gray" value={patient.zip} readOnly="readOnly" />
          </div>
        </div>
        <div className="row justify-content-start">
          <div className="col-md-3 px-md-1">
            <FloatingLabelInput id="schoolName" label="School Name" backcolor="gray" value={patient.schoolName} readOnly="readOnly" />
          </div>
          <div className="col-md-3 px-md-1">
            <FloatingLabelInput id="schoolGradeLevel" label="SchoolGradeLevel" backcolor="gray" value={patient.schoolGradeLevel} readOnly="readOnly" />
          </div>
          <div className="col-md-3 px-md-1">
            <FloatingLabelInput id="guardianFirstName" label="GuardianFirstName" backcolor="gray" value={patient.guardianFirstName} readOnly="readOnly" />
          </div>
          <div className="col-md-3 px-md-1">
            <FloatingLabelInput id="guardianLastName" label="GuardianLastName" backcolor="gray" value={patient.guardianLastName} readOnly="readOnly" />
          </div>
        </div>
      </div>
    </>
  );
};
